import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { EncounterTypeEligibilityImport } from '../models/encounter-type-eligibility-import.model';

export class PagedEncounterTypeEligibilityImports implements PagedResults {
  encounterTypeEligibilityImports: EncounterTypeEligibilityImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.encounterTypeEligibilityImports;
  }
}

@Injectable()
export class EncounterTypeEligibilityImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<EncounterTypeEligibilityImport> {
    return this.http.get<EncounterTypeEligibilityImport>(
      `${environment.captureApi.url}/encounter_type_eligibility_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
  ): Observable<PagedEncounterTypeEligibilityImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedEncounterTypeEligibilityImports>(
      `${environment.captureApi.url}/encounter_type_eligibility_imports?${params.toString()}`
    );
  }

  create(signedId: string): Observable<EncounterTypeEligibilityImport> {
    return this.http.post<EncounterTypeEligibilityImport>(
      `${environment.captureApi.url}/encounter_type_eligibility_imports`,
      {
        encounterTypeEligibilityImport: { signedId },
      }
    );
  }

  cancel(id): Observable<EncounterTypeEligibilityImport> {
    return this.http.patch<EncounterTypeEligibilityImport>(
      `${environment.captureApi.url}/encounter_type_eligibility_imports/${id}/cancel`,
      {}
    );
  }
}
